module.exports = __webpack_public_path__ + "static/img/RW.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/RW.png
// module id = 7r2d
// module chunks = 0